__turbopack_context__.v({
  "breadcumbsContainer": "blogPost-module-scss-module__gTYdFa__breadcumbsContainer",
  "container": "blogPost-module-scss-module__gTYdFa__container",
  "lcResourcesContainer": "blogPost-module-scss-module__gTYdFa__lcResourcesContainer",
  "postContent": "blogPost-module-scss-module__gTYdFa__postContent",
  "section": "blogPost-module-scss-module__gTYdFa__section",
  "sidebar": "blogPost-module-scss-module__gTYdFa__sidebar",
  "subNavBar": "blogPost-module-scss-module__gTYdFa__subNavBar",
});
